import { put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import {
    GET_TARIFF_RATES,
    GET_TARIFF_RATES_SUCCESS,
    GET_TARIFF_RATES_FAILURE,
    GET_TARIFF_RATES_BY_HEAD,
    GET_TARIFF_RATES_BY_HEAD_SUCCESS,
    GET_TARIFF_RATES_BY_HEAD_FAILURE,
    GET_TARIFF_RATE_DETAILS,
    GET_TARIFF_RATE_DETAILS_SUCCESS,
    GET_TARIFF_RATE_DETAILS_FAILURE,
    CREATE_TARIFF_RATE,
    CREATE_TARIFF_RATE_SUCCESS,
    CREATE_TARIFF_RATE_FAILURE,
    UPDATE_TARIFF_RATE,
    UPDATE_TARIFF_RATE_SUCCESS,
    UPDATE_TARIFF_RATE_FAILURE,
    UPDATE_TARIFF_RATE_STATUS,
    UPDATE_TARIFF_RATE_STATUS_SUCCESS,
    UPDATE_TARIFF_RATE_STATUS_FAILURE,
    DELETE_TARIFF_RATE,
    DELETE_TARIFF_RATE_SUCCESS,
    DELETE_TARIFF_RATE_FAILURE
} from '../../../actions/index.types';
import {
    getTariffRatesReq,
    getTariffRatesByHeadReq,
    getTariffRateDetailsReq,
    createTariffRateReq,
    updateTariffRateReq,
    updateTariffRateStatusReq,
    deleteTariffRateReq
} from '../../../../axios/request/SocietyPortal/TariffRateReqs/TariffRateReqs';

// Get All Tariff Rates Saga
function* getTariffRatesSaga(action) {
    try {
        const response = yield getTariffRatesReq(action);
        if (response.success === true) {
            yield put({ type: GET_TARIFF_RATES_SUCCESS, data: response });
        } else {
            yield put({ type: GET_TARIFF_RATES_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to fetch tariff rates");
        }
    } catch (error) {
        yield put({ type: GET_TARIFF_RATES_FAILURE, data: error });
            toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Get Tariff Rates By Head Saga
function* getTariffRatesByHeadSaga(action) {
    try {
        const response = yield getTariffRatesByHeadReq(action);
        if (response.success === true) {
            yield put({ type: GET_TARIFF_RATES_BY_HEAD_SUCCESS, data: response.data });
        } else {
            yield put({ type: GET_TARIFF_RATES_BY_HEAD_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to fetch tariff rates");
        }
    } catch (error) {
        yield put({ type: GET_TARIFF_RATES_BY_HEAD_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Get Tariff Rate Details Saga
function* getTariffRateDetailsSaga(action) {
    try {
        const response = yield getTariffRateDetailsReq(action);
        if (response.success === true) {
            yield put({ type: GET_TARIFF_RATE_DETAILS_SUCCESS, data: response.data });
        } else {
            yield put({ type: GET_TARIFF_RATE_DETAILS_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to fetch tariff rate details");
        }
    } catch (error) {
        yield put({ type: GET_TARIFF_RATE_DETAILS_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Create Tariff Rate Saga
function* createTariffRateSaga(action) {
    try {
        const response = yield createTariffRateReq(action);
        if (response.success === true) {
            yield put({ type: CREATE_TARIFF_RATE_SUCCESS, data: response.data });
            toast.success(response.data.message || "Tariff rate created successfully");
            if (action?.data?.onSuccess) {
                action.data.onSuccess();
            }
        } else {
            yield put({ type: CREATE_TARIFF_RATE_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to create tariff rate");
        }
    } catch (error) {
        yield put({ type: CREATE_TARIFF_RATE_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Update Tariff Rate Saga
function* updateTariffRateSaga(action) {
    try {
        const response = yield updateTariffRateReq(action);
        if (response.success === true) {
            yield put({ type: UPDATE_TARIFF_RATE_SUCCESS, data: response.data });
            toast.success(response.data.message || "Tariff rate updated successfully");
            if (action?.data?.onSuccess) {
                action.data.onSuccess();
            }
        } else {
            yield put({ type: UPDATE_TARIFF_RATE_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to update tariff rate");
        }
    } catch (error) {
        yield put({ type: UPDATE_TARIFF_RATE_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Update Tariff Rate Status Saga
function* updateTariffRateStatusSaga(action) {
    try {
        const response = yield updateTariffRateStatusReq(action);
        if (response.success === true) {
            yield put({ type: UPDATE_TARIFF_RATE_STATUS_SUCCESS, data: response.data });
            toast.success(response.data.message || "Status updated successfully");
            if (action?.data?.onSuccess) {
                action.data.onSuccess();
            }
        } else {
            yield put({ type: UPDATE_TARIFF_RATE_STATUS_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to update status");
        }
    } catch (error) {
        yield put({ type: UPDATE_TARIFF_RATE_STATUS_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Delete Tariff Rate Saga
function* deleteTariffRateSaga(action) {
    try {
        const response = yield deleteTariffRateReq(action);
        if (response.success === true) {
            yield put({ type: DELETE_TARIFF_RATE_SUCCESS, data: response.data });
            toast.success(response.data.message || "Tariff rate deleted successfully");
            if (action?.data?.onSuccess) {
                action.data.onSuccess();
            }
        } else {
            yield put({ type: DELETE_TARIFF_RATE_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to delete tariff rate");
        }
    } catch (error) {
        yield put({ type: DELETE_TARIFF_RATE_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

export default function* TariffRateSaga() {
    yield takeLatest(GET_TARIFF_RATES, getTariffRatesSaga);
    yield takeLatest(GET_TARIFF_RATES_BY_HEAD, getTariffRatesByHeadSaga);
    yield takeLatest(GET_TARIFF_RATE_DETAILS, getTariffRateDetailsSaga);
    yield takeLatest(CREATE_TARIFF_RATE, createTariffRateSaga);
    yield takeLatest(UPDATE_TARIFF_RATE, updateTariffRateSaga);
    yield takeLatest(UPDATE_TARIFF_RATE_STATUS, updateTariffRateStatusSaga);
    yield takeLatest(DELETE_TARIFF_RATE, deleteTariffRateSaga);
}
